import type { TourDefinition } from '../types'

export const mcpToolsTour: TourDefinition = {
  id: 'mcp-tools',
  title: 'MCP Tools Tour',
  description: 'Discover how to register, test, and govern MCP tool calls.',
  icon: 'Wrench',
  route: '/tenant/mcp',
  estimatedMinutes: 3,
  steps: [
    {
      element: '[data-tour-id="mcp-security-banner"]',
      popover: {
        title: 'Security First',
        description: 'All tool calls are scanned for prompt injection and PII. Every invocation is audit-logged.',
      },
      aiContext: 'What security checks does Vharta run on MCP tool calls?',
    },
    {
      element: '[data-tour-id="mcp-tool-card"]',
      popover: {
        title: 'Tool Cards',
        description: 'Each card shows the tool name, risk class (read_only to destructive), and call count.',
      },
      aiContext: 'What do the different MCP tool risk classes mean for my workflow?',
    },
    {
      element: '[data-tour-id="mcp-test-btn"]',
      popover: {
        title: 'Test a Tool',
        description: 'Click Test to open the execution panel. Fill in parameters and run a live call.',
      },
      aiContext: 'How do I safely test an MCP tool without affecting production data?',
    },
    {
      element: '[data-tour-id="mcp-risk-class"]',
      popover: {
        title: 'Risk Classification',
        description: 'Destructive tools require a DB-verified approval before execution — separation of duties enforced.',
      },
      aiContext: 'How do I request approval for a destructive MCP tool call?',
    },
    {
      element: '[data-tour-id="mcp-add-tool-btn"]',
      popover: {
        title: 'Add Custom Tools',
        description: 'Register HTTP endpoints or BYOK connection profiles as MCP tools.',
      },
      aiContext: 'What format does my HTTP endpoint need to be in to register as an MCP tool?',
    },
  ],
}
